const AIPoweredIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_15964_89141)">
      <path
        d="M12.3672 5.33203C12.3672 4.84623 11.9741 4.45312 11.4883 4.45312H7.97266C7.48686 4.45312 7.09375 4.84623 7.09375 5.33203V7.08984C7.09375 7.57564 7.48686 7.96875 7.97266 7.96875C8.45846 7.96875 8.85156 7.57564 8.85156 7.08984V6.21094H11.4883C11.9741 6.21094 12.3672 5.81783 12.3672 5.33203Z"
        fill="white"
      />
      <path
        d="M22.0352 7.96875C22.521 7.96875 22.9141 7.57564 22.9141 7.08984V5.33203C22.9141 4.84623 22.521 4.45312 22.0352 4.45312H18.5195C18.0337 4.45312 17.6406 4.84623 17.6406 5.33203C17.6406 5.81783 18.0337 6.21094 18.5195 6.21094H21.1562V7.08984C21.1562 7.57564 21.5494 7.96875 22.0352 7.96875Z"
        fill="white"
      />
      <path
        d="M11.4883 23.7891H8.85156V22.9102C8.85156 22.4244 8.45846 22.0312 7.97266 22.0312C7.48686 22.0312 7.09375 22.4244 7.09375 22.9102V24.668C7.09375 25.1538 7.48686 25.5469 7.97266 25.5469H11.4883C11.9741 25.5469 12.3672 25.1538 12.3672 24.668C12.3672 24.1822 11.9741 23.7891 11.4883 23.7891Z"
        fill="white"
      />
      <path
        d="M22.0352 22.0312C21.5494 22.0312 21.1562 22.4244 21.1562 22.9102V23.7891H18.5195C18.0337 23.7891 17.6406 24.1822 17.6406 24.668C17.6406 25.1538 18.0337 25.5469 18.5195 25.5469H22.0352C22.521 25.5469 22.9141 25.1538 22.9141 24.668V22.9102C22.9141 22.4244 22.521 22.0312 22.0352 22.0312Z"
        fill="white"
      />
      <path
        d="M7.08984 10.6055C7.08984 9.15152 5.90707 7.96875 4.45312 7.96875C2.99918 7.96875 1.75781 9.15152 1.75781 10.6055C1.75781 12.0594 2.99918 13.2422 4.45312 13.2422C5.90707 13.2422 7.08984 12.0594 7.08984 10.6055Z"
        fill="white"
      />
      <path
        d="M8.84766 17.6367C8.84766 15.2137 6.87615 13.2422 4.45312 13.2422C2.0301 13.2422 0 15.2137 0 17.6367C0 18.1225 0.393105 18.5156 0.878906 18.5156H7.96875C8.45455 18.5156 8.84766 18.1225 8.84766 17.6367Z"
        fill="white"
      />
      <path
        d="M28.2383 10.6055C28.2383 9.15152 26.9969 7.96875 25.543 7.96875C24.089 7.96875 22.9062 9.15152 22.9062 10.6055C22.9062 12.0594 24.089 13.2422 25.543 13.2422C26.9969 13.2422 28.2383 12.0594 28.2383 10.6055Z"
        fill="white"
      />
      <path
        d="M25.5508 13.2422C23.1278 13.2422 21.1562 15.2137 21.1562 17.6367C21.1562 18.1225 21.5494 18.5156 22.0352 18.5156H29.125C29.6108 18.5156 30.0039 18.1225 30.0039 17.6367C30.0039 15.2137 27.9738 13.2422 25.5508 13.2422Z"
        fill="white"
      />
      <path
        d="M18.5156 11.4844C18.5156 9.54545 16.9389 7.96875 15 7.96875C13.0611 7.96875 11.4844 9.54545 11.4844 11.4844C11.4844 13.4233 13.0611 15 15 15C16.9389 15 18.5156 13.4233 18.5156 11.4844Z"
        fill="white"
      />
      <path
        d="M10.6055 22.0312H19.3945C19.8803 22.0312 20.2734 21.6381 20.2734 21.1523V20.2734C20.2734 17.3655 17.9079 15 15 15C12.0921 15 9.72656 17.3655 9.72656 20.2734V21.1523C9.72656 21.6381 10.1197 22.0312 10.6055 22.0312Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_15964_89141">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default AIPoweredIcon
